import React from 'react';
import Layout from "../../shared/components/layouts/MainLayout";
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";

const Intro = ({ goBack, push }) => {
  const renderAdditionalInfo = () => {
    return (
      <section className="cardSection _addDepth">
        <h2 className="copy emphasize _noBottomMargin">Credit limit may increase automatically by paying early</h2>
        <p className="copy">Good payment behavior may automatically increase your credit limit.</p>
        <div className="nudgeTip -danger">
          <i className="materialIcon --micro -danger">info</i>
          <p>Paying late may decrease your credit limit</p>
        </div>
      </section>
    );
  }

  const rendeUploadAction = () => {
    return (
      <a
        className="ds-btn -secondary _marginTop--normal _marginBottom--medium"
        onClick={() => push({ pathname: '/credit-boost/document/new', state: { prevPage: 'creditLimitIntro'} })}
      >
        Upload Recent Business Transactions
      </a>
    );
  }

  const renderInstructionsAndAction = () => {
    return (
      <section className="cardSection">
        <h2 className="subhead">Upload Recent Transactions</h2>
        <p className="copy">Upload your recent transactions with your customers and buyers to help us better understand your business needs.</p>
        {rendeUploadAction()}
        <p className="byline">Note: We will review every document uploaded which may or may not increase your credit limit. </p>
      </section>
    );
  }

  const renderIntroCard = () => {
    return (
      <div className="ds-card _tight">
        {renderInstructionsAndAction()}
        {renderAdditionalInfo()}
      </div>
    );
  }

  return (
    <Layout
      gridClassName='--narrow'
      backButtonAction={goBack}
      header='Apply for Credit Limit Increase'
    >
      {renderIntroCard()}
    </Layout>
  );
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    goBack: () => dispatch(goBack()),
    push: url => dispatch(push(url)),
  }
}

export default connect(null, mapDispatchToProps)(Intro);



// WEBPACK FOOTER //
// ./src/features/CreditLimit/components/Intro.js